import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const generateValueProp = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GENERATE_VALUE_PROPOSITION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/discovery-tree/value-prop`,
            payload,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'GENERATE_VALUE_PROPOSITION_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GENERATE_VALUE_PROPOSITION_FAILED',
              payload: `Failed to create value prop`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GENERATE_VALUE_PROPOSITION_FAILED',
            payload: `Failed to create value prop`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GENERATE_VALUE_PROPOSITION_FAILED',
        payload: `Failed to create value prop`,
      });
    }
  };
};

export default generateValueProp;
